import { Component, OnInit, Input, Optional, Inject } from '@angular/core';
import { BankDepProgram } from '../models/symbol-model';
import { PershingTranslationService } from '@pershing/pershing-core';
import { RateBoardMsgProps } from '../nxi-messages/msg-properties';
@Component({
    selector: 'bank-dep-program',
    templateUrl: './bank-dep-program.component.html'
})
export class BankDepProgramComponent implements OnInit {
    @Input('bankDepProgram') bankDepProgram: Array<BankDepProgram>;
    asOfDate: string;
    public displayedColumns: string[] = ['symbolDesc', 'fmtClosePrice'];
    public rateBoardMsg = RateBoardMsgProps;
    isModernTheme: boolean = false;
    constructor(@Optional() @Inject('AppSettings') appSettings: any, private translationService: PershingTranslationService) {
        if (appSettings.isModernTheme) {
            this.isModernTheme = appSettings.isModernTheme;
        }
        this.translationService.addTranslationFolder('@pershing/nxi-ng-rateboard', 'node_modules/@pershing/nxi-ng-rateboard/lib');
    }

    ngOnInit() {
        this.asOfDate = this.bankDepProgram[0].convertedAsOfDate;
    }

    ngOnDestroy(): void {
        console.log('In BankDepProgram destroy method');
    }
}
